<template>
  <div class="flex items-center space-x-2">
    <icon-base :icon="IconTrigger" />
    <lf-h3>{{ trigger?.title || $t("ORCHESTRATION.TRIGGER") }}</lf-h3>
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";
import { useStore } from "vuex";

import IconTrigger from "@/components/icons/IconTrigger.vue";

import type { IDataService } from "@/models/orchestration";

const { getters } = useStore();

const trigger = computed<IDataService>(() => getters["orchestration/trigger"]);
</script>
